import React, { useEffect, useState } from "react";
import { fetchData, S3_BASE_URL } from "../../Service";
// import he from "he";
import { useSelector } from "react-redux";
// import { fixImagePaths } from "../../components/util";
import Loader from "../../Loader";

// Components
// import SectionTitle from "../../components/Common/SectionTitle";
import SingleServiceFlip from "../../components/Service/SingleServiceFlip";
// import VideoStyleTwo from "../../components/Video/VideoStyleTwo";

const ServiceOneMain = () => {
  const { page } = useSelector((state) => state.data);
  // const [htmlContent, setHtmlContent] = useState(null);
  // const [htmlContent2, setHtmlContent2] = useState(null);
  // const [htmlContent3, setHtmlContent3] = useState(null);

  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);

  // Fetch Services from API
  useEffect(() => {
    const getServices = async () => {
      try {
        const response = await fetchData("/api/v1/service");
        if (response?.success && Array.isArray(response.data)) {
          const formattedServices = response.data.map((service) => ({
            ...service,
            serviceImage: service.serviceImage
              ? `${S3_BASE_URL}/${service.serviceImage}`
              : "",
          }));
          setServices(formattedServices);
        } else {
          setServices([]); // fallback in case data is not array
        }
      } catch (error) {
        console.error("Error fetching services:", error);
        setServices([]);
      } finally {
        setLoadingServices(false);
      }
    };

    getServices();
  }, []);

  // Load CMS content from Redux
  useEffect(() => {
    if (page?.data) {
      const data = page.data;

      if (
        data["services-services"]?.siteId === 2 &&
        data["services-services"].htmlContent
      ) {
        // setHtmlContent(fixImagePaths(data["services-services"].htmlContent));
      }

      if (
        data["service-process"]?.siteId === 2 &&
        data["service-process"].htmlContent
      ) {
        // setHtmlContent2(fixImagePaths(data["service-process"].htmlContent));
      }

      if (
        data["services-getintouch"]?.siteId === 2 &&
        data["services-getintouch"].htmlContent
      ) {
        // setHtmlContent3(fixImagePaths(data["services-getintouch"].htmlContent));
      }
    }
  }, [page]);

  // Show loader while page data is loading

  return (
    <React.Fragment>
      {/* services-area-start */}
      <div className="rs-services style2 pt-120 pb-120 md-pt-80 md-pb-80">
        <div className="container">
          <div className="row">
            {loadingServices ? (
              <Loader />
            ) : Array.isArray(services) && services.length > 0 ? (
              services.map((service) => (
                <div key={service._id} className="col-lg-4 col-md-6 mb-26">
                  <SingleServiceFlip
                    itemClass="flip-box-inner"
                    serviceImage={service.serviceImage}
                    Title={service.title}
                    TextDesc={service.shortDescription.replace(/<\/?p>/gi, "")}
                    ButtonClass="readon view-more"
                    ButtonText="Get In Touch"
                  />
                </div>
              ))
            ) : (
              <p>No services available at the moment.</p>
            )}
          </div>
        </div>
      </div>
      {/* services-area-end */}

      {/* process-area-start */}
      {/* <div className="rs-process style5 bg5 pt-120 pb-120 md-pt-80 md-pb-64">
        {htmlContent2 ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent2 }} />
        ) : (
          ""
        )}
      </div> */}

      {/* Contact Form */}
      {/* <VideoStyleTwo /> */}

      {/* newsletter-area-start */}
      {/* <div className="newsletter-area">
        {htmlContent3 ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent3 }} />
        ) : (
          ""
        )}
      </div> */}
    </React.Fragment>
  );
};

export default ServiceOneMain;
